import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, Eye } from "lucide-react";
import { PageHeader, Panel, BrandButton } from "@/components/PageHeader";
import { RichEditor } from "@/components/notice/RichEditor";
import { NoticeContent } from "@/components/notice/NoticeContent";
import { api, errMsg, fmtDate } from "@/lib/api";

export default function AccountNotice() {
  const [doc, setDoc] = useState(null);
  const [html, setHtml] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/site/signup-notice").then((r) => { setDoc(r.data); setHtml(r.data.html); }).catch((e) => toast.error(errMsg(e)));
  }, []);
  const dirty = doc && html !== doc.html;
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/site/signup-notice", { html }); setDoc({ html: r.data.html, updated_at: new Date().toISOString() }); setHtml(r.data.html); toast.success(r.data.html ? "Important Notice saved" : "Notice cleared. New members go straight to the form"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid="account-notice-page">
      <PageHeader eyebrow="Control" title="Account Notice" description="The Important Notice people must read and confirm before they can create a member account. Leave it empty to skip the notice."
        actions={<BrandButton onClick={save} disabled={busy || !dirty} data-testid="notice-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}Save notice</BrandButton>} />
      {!doc ? <div className="text-gray-500">Loading…</div> : (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-start">
          <div>
            <RichEditor value={doc.html} onChange={setHtml} />
            <p className="text-xs text-gray-500 mt-2" data-testid="notice-status">{dirty ? "Unsaved changes" : doc.updated_at ? `Last saved ${fmtDate(doc.updated_at)}` : "Showing the starter notice. Edit and save it to make it yours."}</p>
          </div>
          <Panel title={<span className="inline-flex items-center gap-2"><Eye className="w-4 h-4" />What people will see</span>} testId="notice-preview">
            <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#E60000]">Before you create your account</div>
            <h2 className="font-heading text-2xl font-extrabold tracking-tight mt-1 mb-4">Important Notice</h2>
            {html ? <NoticeContent html={html} testId="notice-preview-content" /> : <p className="text-sm text-gray-500">No notice. People go straight to the account form.</p>}
          </Panel>
        </div>
      )}
    </div>
  );
}
